import ActionTypes from '../constants/ActionTypes'; 

const initialState = {
    loading: false,
    data: {},
    error: null,
};

const confirmFirstMonthReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_CONFIRM_FIRST_MONTH_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.FETCH_CONFIRM_FIRST_MONTH_SUCCESS:
            return { ...state, loading: false, data: action.payload};
        case ActionTypes.FETCH_CONFIRM_FIRST_MONTH_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default confirmFirstMonthReducer;
